import { NavBar } from "./NavBar";
import { Footer } from "./Footer";
import { PortfolioContentThree } from "./projectThree/PortfolioContentThree";

export const PortfolioFullyCaptured = () => {
  return (
    <div>
      <NavBar />
      <PortfolioContentThree />
      <Footer />
    </div>
  );
};
